import React from 'react';
import { motion } from 'framer-motion';
import { SectionWrapper, childVariants } from './SectionWrapper';
export function TransformSection() {
  return <SectionWrapper data-id="element-435">
      <motion.h2 className="font-heading text-2xl md:text-3xl font-bold text-cream mb-10" variants={childVariants} data-id="element-436">
        What changes when you have a protocol
      </motion.h2>

      <motion.p className="font-body text-lg text-cream leading-loose-plus mb-4" variants={childVariants} data-id="element-437">
        You stop fearing bedtime.
      </motion.p>

      <motion.p className="font-body text-lg text-cream leading-loose-plus mb-8" variants={childVariants} data-id="element-438">
        You stop thinking,{' '}
        <em className="text-cream-muted" data-id="element-439">"If I wake up, I'm doomed."</em>
      </motion.p>

      <motion.p className="font-body text-lg text-cream leading-loose-plus mb-4" variants={childVariants} data-id="element-440">
        Because you already know what happens next:
      </motion.p>

      <motion.p className="font-heading text-xl md:text-2xl text-teal-light font-semibold leading-relaxed-plus mb-10" variants={childVariants} data-id="element-441">
        You Run The system.
      </motion.p>

      <motion.p className="font-body text-lg text-cream leading-loose-plus mb-4" variants={childVariants} data-id="element-442">
        Even if you still wake up sometimes, you don't lose the whole night.
      </motion.p>

      <motion.p className="font-heading text-xl text-amber font-medium italic leading-relaxed-plus" variants={childVariants} data-id="element-443">
        That's the win.
      </motion.p>
    </SectionWrapper>;
}